import React, { Component } from "react";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import { Menu } from "antd";

import { connect } from "react-redux";
import { act_setHeadTitle } from "../../redux/actions";

import { req_add_loginfo } from "../../api";

import { SYS_CODE, ORG_CODE } from "../../utils/contrains";
import { usrPlatform } from "../../utils/dataUtil";

import memoryUtils from "../../utils/memoryUtils";
import menuList from "../../configs/menuConfig";

import logo from "../../assets/images/logo.png";
import "./index.less";

const { SubMenu } = Menu;

class MainLeftNav extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    menus: [],
  };

  UNSAFE_componentWillMount() {
    // this.menus = this.getReduceMenuNodes(menuList)
    this.init();
  }

  componentDidMount() {
    // console.log("setUserInfo");
    this.setUserInfo();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_add_log = async (item) => {
    const { token } = this.props.user;
    await req_add_loginfo(item, token);
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    let menus = this.getReduceMenuNodes(menuList);
    this.setState({ menus });
  };

  onlyShowAuthMenus = (item) => {
    /*
    1. 當前用戶是ADMIN
    2. 如果當前item是公開的
    3. 當前用戶有此item：key有沒有在menus中
   */
    const { key, isPublic } = item;
    const menus = this.props.user.menus;
    //console.log("left-menus:", menus);
    //const userCode = this.props.user.userCode;
    //console.log("left-userCode:", userCode);
    //userCode.toLowerCase() === 'adminuser' ||
    if (isPublic || menus.indexOf(key) !== -1) {
      return true;
    } else if (item.children) {
      // 如果當前用戶有此item的某個子item的權限
      return !!item.children.find((child) => menus.indexOf(child.key) !== -1);
    }
    return false;
  };

  getMapMenuNodes = (menuList) => {
    return menuList.map((item) => {
      if (this.onlyShowAuthMenus(item)) {
        if (!item.children) {
          return (
            <Menu.Item key={item.key} icon={item.icon}>
              {item.isBlank ? (
                <a rel="noopener noreferrer" href={item.key} target="_blank">
                  {" "}
                  {item.title}
                </a>
              ) : (
                <Link
                  to={item.key}
                  key={item.key}
                  onClick={() => {
                    this.props.act_setHeadTitle(item.title);
                  }}
                >
                  {item.title}
                </Link>
              )}
            </Menu.Item>
          );
        } else {
          return (
            <SubMenu key={item.key} icon={item.icon} title={item.title}>
              {this.getMapMenuNodes(item.children)}
            </SubMenu>
          );
        }
      } else {
        return true;
      }
    });
  };

  getReduceMenuNodes = (menuList) => {
    const path = this.props.location.pathname;
    return menuList.reduce((item_pre, item) => {
      // 如果當前用戶有item才顯示
      if (this.onlyShowAuthMenus(item)) {
        if (!item.children) {
          item_pre.push(
            <Menu.Item key={item.key} icon={item.icon}>
              {item.isBlank ? (
                <a rel="noopener noreferrer" href={item.key} target="_blank">
                  {" "}
                  {item.title}
                </a>
              ) : (
                <Link to={item.key} key={item.key}>
                  {item.title}
                </Link>
              )}
            </Menu.Item>
          );
        } else {
          // 針對點開的項目是二級選項，對其清單下所有子項目全展開
          const selected_item_child = item.children.find(
            (item_child) => path.indexOf(item_child.key) === 0
          );
          if (selected_item_child) {
            this.openKey = item.key;
          }

          item_pre.push(
            <SubMenu key={item.key} icon={item.icon} title={item.title}>
              {this.getMapMenuNodes(item.children)}
            </SubMenu>
          );
        }
      }
      // console.log(this.onlyShowAuthMenus(item))
      return item_pre;
    }, []);
  };

  setUserInfo = () => {
    const { userCode } = this.props.user;
    const _device = {
      orgCode: ORG_CODE,
      sysCode: SYS_CODE,
      accountCode: userCode,
      clientIP: "0.0.0.0",
      clientCity: "",
      platform: "",
      os: "",
      osVersion: "",
      browser: "",
      browserVersion: "",
      latitude: 0.0,
      longitude: 0.0,
      description: "",
    };
    // 判斷作業系統
    const platformInfo = usrPlatform();
    // console.log("platformInfo:", platformInfo);
    // 判斷地理位置
    // const localInfo = usrLocation();
    // console.log("localInfo:", localInfo);
    // 使用 ip-api.com 取回 IP 與地理資訊；ipapi.co 在部分環境無法使用
    axios
      .get("https://ip-api.com/json/")
      .then((response) => {
        let data = response.data;
        if (data) {
          // ip-api 回傳欄位: query (ip), regionName, city, lat, lon
          _device.clientIP = data.query || _device.clientIP;
          _device.clientCity = data.regionName || data.city || _device.clientCity;
          _device.latitude = typeof data.lat === "number" ? data.lat : _device.latitude;
          _device.longitude = typeof data.lon === "number" ? data.lon : _device.longitude;
        }
        if (platformInfo) {
          _device.platform = platformInfo.platform;
          _device.os = platformInfo.system;
          _device.osVersion = platformInfo.systemVs;
          _device.browser = platformInfo.supporter;
          _device.browserVersion = platformInfo.supporterVs;
        }
        _device.description = "登入成功";

        memoryUtils.device = _device;
        this.api_add_log(_device);
      })
      .catch((error) => {
        // 若失敗，可以考慮加入備援 API 或記錄錯誤
        // console.error("get geo info failed:", error);
        if (platformInfo) {
          _device.platform = platformInfo.platform;
          _device.os = platformInfo.system;
          _device.osVersion = platformInfo.systemVs;
          _device.browser = platformInfo.supporter;
          _device.browserVersion = platformInfo.supporterVs;
        }
        _device.description = "登入成功";
        memoryUtils.device = _device;
        this.api_add_log(_device);
      });
  };

  ////////////////////////////////////////////////////////////
  render() {
    const { menus } = this.state;
    // const menus = this.menus
    let path = this.props.location.pathname;
    // console.log("path", path);
    if (path.indexOf("/work/business") === 0) {
      // 當前請求的是商品或其子路由介面
      path = "/work/business";
    }
    if (path.indexOf("/fixcomputer/applycase") === 0) {
      // 當前請求的是applycase或其子路由介面
      path = "/fixcomputer/applycase";
    }
    if (path.indexOf("/fixcomputer/reviewcase") === 0) {
      // 當前請求的是reviewcase或其子路由介面
      path = "/fixcomputer/reviewcase";
    }
    if (path.indexOf("/fixcomputer/historyreviewcase") === 0) {
      // 當前請求的是historyreviewcase或其子路由介面
      path = "/fixcomputer/historyreviewcase";
    }
    if (path.indexOf("/learnpoints/activity") === 0) {
      // 當前請求的是activity或其子路由介面
      path = "/learnpoints/activity";
    }
    if (path.indexOf("/learnpoints/course") === 0) {
      // 當前請求的是course或其子路由介面
      path = "/learnpoints/course";
    }
    if (path.indexOf("/culturalcreativeworks/works") === 0) {
      // 當前請求的是works或其子路由介面
      path = "/culturalcreativeworks/works";
    }
    if (path.indexOf("/culturalcreativeworks/course") === 0) {
      // 當前請求的是course或其子路由介面
      path = "/culturalcreativeworks/course";
    }
    const openKey = this.openKey;
    return (
      <>
        <div className="main-left-nav">
          <Link to="/" className="main-left-nav-header">
            <img src={logo} alt="logo" />
            <h1>功能清單</h1>
          </Link>
          <Menu
            selectedKeys={[path]}
            defaultOpenKeys={[openKey]}
            mode="inline"
            theme="dark"
            style={{ backgroundColor: "#301356" }}
          >
            {menus}
          </Menu>
        </div>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), { act_setHeadTitle })(
  withRouter(MainLeftNav)
);
